var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.readonly)?_c('div',{staticClass:"readonly-mode-field"},[_vm._v(_vm._s(_vm.fullLabel))]):_c('el-cascader',_vm._g({ref:"input",attrs:{"value":_vm.cityValue,"separator":"/","clearable":"","props":_vm.props},on:{"input":_vm.setCity}},_vm.vm_listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }